import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class AmenityService {
    categories: string[] = [ "Property Style", "Community Features", "Essential", "Comfort and Convenience", "Outdoor", "Waterfront and Boating", "Luxury and Recreation", "Family and Pet-Friendly", "Location-Specific", "Eco-Friendly and Smart", "Unique or Local", "Accessibility", "Safety and Practical"];
    
    getAmenityCategories() {
        return this.categories;
    }

    getCategoryIcon(category: string) {
        switch (category) {
        case "Property Style":
            return 'villa';          // or 'house' / 'apartment' / 'villa'
            break;
        case "Community Features":
            return 'park';           // or 'diversity_3' / 'people' / 'park'
            break;
        case "Waterfront and Boating":
            return 'directions_boat';
            break;
        case "Essential":
            return 'wifi'
            break;
        case "Comfort and Convenience":
            return 'ac_unit'
            break;
        case "Outdoor":
            return 'beach_access'
            break;
        case "Luxury and Recreation":
            return 'spa'
            break;
        case "Family and Pet-Friendly":
            return 'pets'
            break;
        case "Location-Specific":
            return 'local_activity'
            break;
        case "Eco-Friendly and Smart":
            return 'eco'
            break;
        case "Unique or Local":
            return 'public'
            break;
        case "Accessibility":
            return 'accessible'
            break;
        case "Safety and Practical":
            return 'security'
            break;
        default:
            return '';
        }
    }
}